var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "checkbox" }, [
    _c("label", [
      _c("input", {
        attrs: { type: "checkbox", disabled: !_vm.enabled },
        domProps: { checked: _vm.controlValue.data },
        on: { change: _vm.onChange },
      }),
      _vm._v("\n        " + _vm._s(_vm.controlValue.label) + "\n    "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }